$('#date-mode-tabs a').on('shown.bs.tab', function (e) {
    const tabId = $(e.target).attr('href');
    $('input[name="mode"]').val(tabId === '#single-date' ? 'single' : 'range');
});

if ($('#add-placement-dates-modal').length) {
    $('#single-date, #range-start, #range-end').datetimepicker({
        timepicker: false,
        format: 'Y-m-d',
        minDate: `${academicYear}-09-01`,
        maxDate: `${academicYear + 1}-08-31`,
    });

    // When range-start changes, update range-end
    $('#range-start').on('change', function () {
        const startDate = $(this).val();
        if (startDate !== '') {
            const nextDay = new Date(startDate);
            nextDay.setDate(nextDay.getDate() + 1);

            const year  = nextDay.getFullYear();
            const month = String(nextDay.getMonth() + 1).padStart(2, '0');
            const day   = String(nextDay.getDate()).padStart(2, '0');

            const formattedNextDay = `${year}-${month}-${day}`;

            $('#range-end').datetimepicker({ minDate: formattedNextDay });

            // Only update range-end value if it is empty or earlier than new minDate
            const currentEnd = $('#range-end').val();
            if (currentEnd === '' || new Date(currentEnd) < nextDay) {
                $('#range-end').val(formattedNextDay);
            }
        }
    });
}

$('.delete-placement-date').on('click', function () {
    var button                = $(this);
    var modal                 = $('#delete-placement-date-modal');
    var dateId                = $(button).data('date-id');
    var placementDateReadable = $(button).data('placement-date-readable');
    var idField               = $(modal).find('input[type="hidden"][name="date-id"]');
    var placementDateText     = $(modal).find('span.placement-date-readable');

    $(idField).val(dateId).change();
    $(placementDateText).text(placementDateReadable);
});
